import React, { useState } from 'react';
import { BOTTOM_INDENTS, brandsOpenApi, COLORS } from '@constants';
import { useNotification } from '@hooks';
import { Button, Icon, Input, Typography, WhiteCover } from '@ui';
import { axiosBoa, getErrorMessage } from '@utils';
import { Flex, Form } from 'antd';
import CoverTitle from '../CoverTitle';

const INTEGRATION_NAME_RULES = [
    {
        required: true,
        whitespace: true,
        message: <span data-e2e='common_required-field_error'>This field is required</span>
    },
    { max: 255, message: 'Name should be at most 255 characters' }
];

const IntegrationRequest = () => {
    const [form] = Form.useForm();
    const notification = useNotification();
    const [submitting, setSubmitting] = useState(false);

    const handleFinish = async ({ integrationName }) => {
        setSubmitting(true);
        try {
            await axiosBoa.post(brandsOpenApi.integrations.request, { integrationName: integrationName.trim() });
            notification.success({ message: 'Your request has been sent' });
            form.resetFields();
        } catch (error) {
            notification.error({ message: getErrorMessage(error).description });
        } finally {
            setSubmitting(false);
        }
    };

    return (
        <WhiteCover
            data-e2e='integrations_request_section'
            customTitle={
                <CoverTitle
                    title='Need a different integration?'
                    iconSize='80px'
                    iconColor={COLORS.$gray60Black}
                    icon={<Icon.AddMoreProductsIcon />}
                />
            }
            style={BOTTOM_INDENTS.M}
        >
            <Typography.Text type='body2' color={COLORS.$gray60Black} style={BOTTOM_INDENTS.M}>
                If your integration isn&apos;t listed, reach out to us to request a custom solution.
            </Typography.Text>
            <Form form={form} onFinish={handleFinish}>
                <Flex gap={16} align='flex-start'>
                    <Form.Item
                        name='integrationName'
                        rules={INTEGRATION_NAME_RULES}
                        style={{ flex: 1, marginBottom: 0 }}
                    >
                        <Input
                            data-e2e='integrations_request-name_input'
                            data-lpignore='true'
                            placeholder='Integration name'
                            disabled={submitting}
                        />
                    </Form.Item>
                    <Button
                        data-e2e='integrations_request-send_btn'
                        type='primary'
                        htmlType='submit'
                        loading={submitting}
                        style={{ width: 160 }}
                    >
                        Send a Request
                    </Button>
                </Flex>
            </Form>
        </WhiteCover>
    );
};

export default IntegrationRequest;
